import { render, staticRenderFns } from "./ContractProfileTemplateForm.vue?vue&type=template&id=52c16622&scoped=true&"
import script from "./ContractProfileTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./ContractProfileTemplateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c16622",
  null
  
)

export default component.exports